/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, bool, array, object, shape, func } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import md5 from 'md5';
import classNames from 'clsx';
import { storage } from 'utils/storage';

import { AUTH_SUCCESS } from 'actions/auth';

import Form from 'components/Form/Form';

import styles from './email-password-form.scss';

/**
 * This is the EmailPasswordForm component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class EmailPasswordForm extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    authenticate: func.isRequired,
    passwordAuthenticateForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    disabled: bool,
    light: bool,
    wide: bool,
  };

  static defaultProps = {
    disabled: false,
    light: false,
    wide: false,
  };

  onSubmit = data => {
    const { authenticate } = this.props;
    const { email, password } = data;

    authenticate({
      email,
      password_hash: md5(password),
    }).then(({ type }) => {
      if (type === AUTH_SUCCESS) {
        storage.write('email', email);
        storage.write('password_hash', md5(password));
      }
    });
  };

  /**
   * Render EmailPasswordForm.
   *
   * @return {Object}
   */
  render() {
    const { passwordAuthenticateForm, light, wide, disabled } = this.props;

    return (
      <div
        className={classNames(styles.wrapper, {
          [styles.disabled]: disabled,
        })}
      >
        <Form
          {...passwordAuthenticateForm}
          light={light}
          onSubmit={this.onSubmit}
          autoComplete="on"
          wide={wide}
          scrollToTop={false}
        />
      </div>
    );
  }
}

export default withRouter(
  connect(({ passwordAuthenticateForm }) => ({ passwordAuthenticateForm }))(
    EmailPasswordForm
  )
);
